import { graphql } from '@e-socna/data-layer';

export const NavigationContext_FolderSpaceInfo_Folder_Fragment = graphql(`
  fragment NavigationContext_FolderSpaceInfo_Folder_Fragment on Folder {
    businessEventIds
    fileDirectory {
      files {
        _id
        hideInFileExplorer
      }
    }
    _id
    stateId
    missions {
      kind
    }
  }
`);
